import { render, staticRenderFns } from "./thematicArea.vue?vue&type=template&id=3a20b024"
import script from "./thematicArea.vue?vue&type=script&lang=js"
export * from "./thematicArea.vue?vue&type=script&lang=js"
import style0 from "./thematicArea.vue?vue&type=style&index=0&id=3a20b024&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports